// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationBusinessInsightsPath = 'M2 7h96v7h-4v48h4v7H53.5v7.9c0 5.6 2.4 8.8 9.4 12.6l6.3 3.4-3.4 6.2-6.3-3.5c-3.655-1.964-7.19-4.314-9.65-7.7-2.442 3.172-5.84 5.414-9.35 7.3l-6.3 3.5-3.4-6.2 6.3-3.4c7-3.8 9.4-7 9.4-12.6V69H2v-7h5V14H2V7zm12 55h73V14H14v48zm64.2-25.9L79.4 20l-15.7 4.1 4.91 4.063L62.2 37l-10.9-9.1-9.7 13.9-8.7-7.2L20 52.7l5.7 4.1 8.5-12 8.7 7.3 9.8-14 10.8 9 10.522-14.458L78.2 36.1z';
var IllustrationBusinessInsights = baseIllustration('IllustrationBusinessInsights', {
  getPath: () => IllustrationBusinessInsightsPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationBusinessInsights;
//# sourceMappingURL=index.js.map